export const TYPE_STUDIO = 1;
export const TYPE_PREP = 2;
export const TYPE_SET = 3;
export const TYPE_COPY = 4;
export const TYPE_TRANSLATION_FRENCH = 5;
export const TYPE_TRANSLATION_JAPANESE = 6;
export const TYPE_TRANSLATION_CHINESE = 7;
export const TYPE_RETOUCH = 8;
export const TYPE_MERCHANDISE_COORDINATION = 9;
export const TYPE_PLANNING_PRODUCING = 10;
export const TYPE_ACC_PREP = 11;
export const TYPE_COPY_PREP = 12;
export const TYPE_INVENTORY_PREP = 13;
export const TYPE_POIRIER_SET = 14;
export const TYPE_ASSISTANT_TEAM = 15;

export const LOCATION_TYPES = {
  PREP: {
    id: TYPE_PREP,
    name: 'PREP'
  },
  STUDIO: {
    id: TYPE_STUDIO,
    name: 'STUDIO'
  },
  SET: {
    id: TYPE_SET,
    name: 'SET'
  },
  COPY: {
    id: TYPE_COPY,
    name: 'COPY'
  },
  RETOUCH: {
    id: TYPE_RETOUCH,
    name: 'RETOUCH'
  },
  ACC_PREP: {
    id: TYPE_ACC_PREP,
    name: 'ACC_PREP'
  },
  COPY_PREP: {
    id: TYPE_COPY_PREP,
    name: 'COPY_PREP'
  },
  INVENTORY_PREP: {
    id: TYPE_INVENTORY_PREP,
    name: 'INVENTORY_PREP'
  },
  POIRIER_SET: {
    id: TYPE_POIRIER_SET,
    name: 'POIRIER SET'
  },
}

export const numberOfSetSupportedLocations = [
  TYPE_STUDIO,
  TYPE_PREP,
  TYPE_SET,
  TYPE_ACC_PREP,
];
